let mutations = {
  setState(state, newState) {},
  // 更新用户信息
  setUserInfo(state, userInfo) {
    if(!userInfo) return;
    state.userInfo.user_id = userInfo.user_id;
    state.userInfo.username = userInfo.username;
    state.userInfo.avatar = userInfo.avatar;
    state.userInfo.role = userInfo.role;
    state.userInfo.gender = userInfo.gender;
    state.userInfo.wechat_subscribe = userInfo.wechat_subscribe;
    state.userInfo.token = userInfo.token;
    state.userInfo.user_token = userInfo.user_token;
    state.userInfo.status = userInfo.status;
    state.userInfo.doc_status = userInfo.doc_status;
    state.userInfo.doc_money = userInfo.doc_money;
    state.userInfo.hasDoctor = userInfo.hasDoctor;
    state.userInfo.doctor_type = userInfo.type;
  },
  // 更新oss上传签名信息
  setUploadParams(state, params) {
    state.uploadParams = params;
  },
  setChatList(state, list) {
    state.chatList = list;
  },
  updateLastMessage(state, payload) {
    state.chatList[payload.index].latestMessage = payload.message;
  },
  setPrescriptionData(state, data) {
    state.prescriptionData = data;
  },
  clearPrescriptionData(state) {

    state.prescriptionData = null;
  },
  setHerbsData(state, data) {
    state.herbsData = data;
  },
  clearHerbsData(state) {
    state.herbsData = [];
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutation.js